module.exports = __webpack_public_path__ + "media/images/logo_oms-0e50020855b2127fa6491113170c8717.png";